import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { catchError, map, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { SessionTimeoutOptions } from "@surescripts/core";

export const authenticationGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const http = inject(HttpClient);

  return http.get<CheckSessionResponse>(new SessionTimeoutOptions().checkSessionEndpoint)
    .pipe(map(checkSessionResponse => {
      if (!checkSessionResponse.isSessionValid) {
        router.navigate(['account/login']);
      }
      return checkSessionResponse.isSessionValid;
    }),
      catchError(() => {
        return of(false);
      }));
}
class CheckSessionResponse {
  isSessionValid: boolean;
  sessionExpiresMilliseconds: number;
}
